export const CREATE_MUSIC = 'MUSIC/CREATE';
export const CREATE_PLAYLIST = 'PLAYLIST/CREATE';
export const LOAD_PLAYLIST = 'PLAYLIST/LOAD';
export const DELETE_MUSIC = 'MUSIC/DELETE';
export const DELETE_pLAYLIST = 'PLAYLIST/DELETE';
export const LOADING_STATUS = 'MUSIC/LOADING_STATUS';
export const UPDATE_UPLOAD_PROGRESS = 'MUSIC/UPDATE_UPLOAD_PROGRESS';
